import { useState } from 'react'
import PropTypes from 'prop-types'

import Styled from './berthing-pagination.styles'
import { Colors } from '~/styles'

const BerthingPagination = ({ data, methods }) => {
  const [isHoveringButton, setIsHoveringButton] = useState(false)

  return (
    <>
      {Math.ceil(data.totalData / data.viewPerPage) > 1 && (
        <Styled.PaginationContainer>
          <Styled.PaginationButton
            onClick={methods.handleChangePrevious}
            disabled={data.skip === 0}
            onMouseEnter={() => setIsHoveringButton(true)}
            onMouseLeave={() => setIsHoveringButton(false)}
          >
            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path opacity='0.54' d='M15.4081 17.085L10.8293 12.4993L15.4081 7.91357L13.9985 6.50488L8 12.4993L13.9985 18.4937L15.4081 17.085Z' fill={isHoveringButton ? Colors.white : Colors.black} />
            </svg>
          </Styled.PaginationButton>

          <Styled.PaginationIndicatorContainer visible={isHoveringButton}>
            {Array.from({ length: Math.ceil(data.totalData / data.viewPerPage) }, (_, index) => (
              <Styled.PaginationIndicator key={index} active={data.pageNumber === index + 1} />
            ))}
          </Styled.PaginationIndicatorContainer>

          <Styled.PaginationButton
            onClick={methods.handleChangeNext}
            disabled={data.skip + data.viewPerPage >= 5}
            onMouseEnter={() => setIsHoveringButton(true)}
            onMouseLeave={() => setIsHoveringButton(false)}
          >
            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path opacity='0.54' d='M8.59375 16.336L13.1726 11.7503L8.59375 7.16454L10.0034 5.75586L16.0019 11.7503L10.0034 17.7447L8.59375 16.336Z' fill={isHoveringButton ? Colors.white : Colors.black} />
            </svg>
          </Styled.PaginationButton>
        </Styled.PaginationContainer>
      )}
    </>
  )
}

BerthingPagination.propTypes = {
  data: PropTypes.shape({
    skip: PropTypes.number.isRequired,
    totalData: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    viewPerPage: PropTypes.number.isRequired,
  }).isRequired,
  methods: PropTypes.shape({
    handleChangeNext: PropTypes.func.isRequired,
    handleChangePrevious: PropTypes.func.isRequired,
  }).isRequired
}

export default BerthingPagination